module.exports = __webpack_public_path__ + "media/images/favicon-17bdd2cfeebfff682e9f59e0485029c5.ico";